import * as React from 'react';

import { Link } from 'libs/router';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

const ICON_COMPONENTS = {
  add: 'plus-inside-circle-custom-bg',
  edit: 'pencil-inside-circle-custom-fg',
  list: 'list-custom-bg',
  view: 'eye-custom-bg',
  incomplete: 'exclamation-inside-circle-custom-bg',
  delete: 'trash-custom-fg',
  euro: 'euro-inside-circle-custom-fg'
};

type AdminItem = {
  to: string,
  name: string,
  icon: 'add' | 'edit' | 'list' | 'view' | 'incomplete' | 'delete' | 'euro'
};

type Props = {
  title: string,
  items: Array<AdminItem>
};

const AdminDashboardSection = ({
  items,
  title
}: Props) => (
  <div className="admin-dashboard-section">
    <div className="admin-dashboard-section__title">
      {title}
    </div>
    <div className="admin-dashboard-section__content">
      {
        items.map(item => (
          <p key={item.to}>
            <span className="admin-dashboard-section__icon">
              <SVGDynamicIcon
                name={ICON_COMPONENTS[item.icon]}
                customColor="grey"
                width={18}
                height={18}
              />
            </span>
            <Link to={item.to}>
              {item.name}
            </Link>
          </p>
        ))
      }
    </div>
  </div>
);

export default AdminDashboardSection;
